var DualRowPackageData = require('./dualRowPackageData.js');
var lib_core = require("lib-core");
var lib_geometry = require("lib-geometry");
var EllipseData = require('../../../svg/ellipseData.js');
var PathData = require('../../../svg/pathData.js');
var PathObjectData = require('../../../svg/pathObjectData.js');
var PathType = require('../../../svg/pathType.js');
var IPCRules = require('../ipcRules');
var ComponentAttribute = require('./componentAttribute.js');

var MelfData = function(position, angle, init) {
    DualRowPackageData.apply(this, arguments);

    //component family if any
    this.componentFamily = this.value("componentFamily", true);

    this.nonTransformedSegmentedGeometry.addTrigger(this.componentFamily);
};

lib_core.inherit(MelfData, DualRowPackageData);
lib_core.JsonParser.registerClass(MelfData, "MelfData");

module.exports = MelfData;

/**
 * Calculate pads geometry
 * @param  {boolean} absolutePositions
 * @return {array} Array of pads.
 */
MelfData.prototype.getPads = function(absolutePositions) {
    var pads = [];

    //reset component
    this.component.reset();
    this.updateComponentCalculator(this.horizontalLeadToLeadSpanMin(), this.horizontalLeadToLeadSpanMax());

    var motif = this.getMotif(),
        hPitch = this.component.C;

    //left pad
    var pad = motif.clone();
    pad.move(new lib_geometry.Coord(-0.5 * hPitch, 0));
    pads.push(pad);

    //right pad
    pad = motif.clone();
    pad.move(new lib_geometry.Coord(0.5 * hPitch, 0));
    pads.push(pad);

    this.updatePads(pads, absolutePositions);
    return pads;
};

MelfData.prototype.getSilkscreen = function(pads) {
    var silkscreen = [];

    //no silkscreen if there are no pads
    if(pads.length === 0) return silkscreen;

    var body = this.getBodyForSilkscreen(),
    	leftPad = pads[0],
        rightPad = pads[1],
        pathData;

    var topLineY;
    var bottomLineY;
    var lineStartX;
    var lineEndX = rightPad.getPos().x - rightPad.getTopCopper().width() / 2;

    if(leftPad.getPos().y + leftPad.getTopCopper().height() / 2 + IPCRules.silkscreenClearance + IPCRules.silkscreenStrokeWidth / 2 > body.height / 2) {
        topLineY = leftPad.getPos().y + leftPad.getTopCopper().height() / 2 + IPCRules.silkscreenClearance + IPCRules.silkscreenStrokeWidth / 2;
        bottomLineY = leftPad.getPos().y - leftPad.getTopCopper().height() / 2 - IPCRules.silkscreenClearance - IPCRules.silkscreenStrokeWidth / 2;
    } else {
        topLineY = body.height / 2;
        bottomLineY = - body.height / 2;
    }

    if(this.componentFamily() === ComponentAttribute.melfComponentFamily["DIODE"]) {
        lineStartX = leftPad.getPos().x - leftPad.getTopCopper().width() / 2 - IPCRules.silkscreenClearance - IPCRules.silkscreenStrokeWidth / 2;

        pathData = new PathData(new lib_geometry.Coord(lineEndX, topLineY), IPCRules.silkscreenStrokeWidth);
        pathData.addObject(new PathObjectData(new lib_geometry.Coord(lineStartX, topLineY), PathType.LINE));
        pathData.addObject(new PathObjectData(new lib_geometry.Coord(lineStartX, bottomLineY), PathType.LINE));
        pathData.addObject(new PathObjectData(new lib_geometry.Coord(lineEndX, bottomLineY), PathType.LINE));
        silkscreen.push(pathData);
    } else {
        lineStartX = leftPad.getPos().x + leftPad.getTopCopper().width() / 2;

        //top line
        pathData = new PathData(new lib_geometry.Coord(lineEndX, topLineY), IPCRules.silkscreenStrokeWidth);
        pathData.addObject(new PathObjectData(new lib_geometry.Coord(lineStartX, topLineY), PathType.LINE));
        silkscreen.push(pathData);

        //bottom line
        pathData = new PathData(new lib_geometry.Coord(lineStartX, bottomLineY), IPCRules.silkscreenStrokeWidth);
        pathData.addObject(new PathObjectData(new lib_geometry.Coord(lineEndX, bottomLineY), PathType.LINE));
        silkscreen.push(pathData);
    }

    return silkscreen;
};
